/**
 * Class to check the origin of the application.
 * @example
 * if (Origin.isBW) {
 *  // Do something
 * }
 * if (Origin.isHC) {
 *  // Do something
 * }
 */
class Origin {
  private static bwRegExp = new RegExp(
    /^http(s)?:\/\/(local\.)?(.*-)?(app|bw)(-vlc|-vulcano)?\.(hotmart|buildstaging)\.com/
  );
  private static hcRegExp = new RegExp(/^http(s)?:\/\/(local\.)?(.*-)?help\.(hotmart|buildstaging)\.com/);

  /**
   * Return true if matches the Business Workspace origin.
   * Origin examples:
   * - https://app.buildstaging.com
   * - https://featureir1042-app.buildstaging.com
   * - http://local.app.buildstaging.com
   * - http://local.bw.buildstaging.com
   * - https://app-vlc.hotmart.com
   * - https://app-vulcano.hotmart.com
   * - https://app.hotmart.com
   */
  static get isBW() {
    return Origin.bwRegExp.test(window.location.origin);
  }

  /**
   * Return true if matches the Help Center origin.
   * Origin examples:
   * - https://help.buildstaging.com
   * - https://featureir1042-help.buildstaging.com
   * - http://local.help.buildstaging.com
   * - https://help.hotmart.com
   */
  static get isHC() {
    return Origin.hcRegExp.test(window.location.origin);
  }
}

export default Origin;
